module.exports = __webpack_public_path__ + "assets/img/102101.ac3a1360.svg";